module.exports = __webpack_public_path__ + "static/media/china-flag.15563804.png";